import Dialog from ".";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useState, useEffect } from "react";
import { baseAxios } from "../../apis";
import useAuthedApi from "../../hooks/useAuthedApi";

const DialogTour = ({
  open,
  onClose,
  steps = [],
  tourKey, // "dashboard", "botlist", etc
}) => {
  const { authedPatch } = useAuthedApi();
  const [index, setIndex] = useState(0);

  const current = steps[index];

  useEffect(() => {
    if (open) {
      setIndex(0);
    }
  }, [open]);

  if (!current) return null;

  const handleClose = async () => {
    // Disable current tour type locally
    if (tourKey) {
      localStorage.setItem(`tour_disabled_${tourKey}`, "true");
    }

    // Check if both tours have been completed
    const dashboardDone = localStorage.getItem("tour_disabled_dashboard");
    const botlistDone = localStorage.getItem("tour_disabled_botlist");

    const shouldTriggerBackend =
      dashboardDone === "true" && botlistDone === "true";

    if (shouldTriggerBackend) {
      try {
        await authedPatch("/api/user/deactivate-tooltip");
        console.log("Tooltip deactivated globally");
      } catch (err) {
        console.error("Error disabling tooltip:", err);
      }
    }

    setIndex(0);
    onClose?.();
  };

  const handleNext = () => {
    if (index < steps.length - 1) setIndex((i) => i + 1);
  };

  const handleBack = () => {
    if (index > 0) setIndex((i) => i - 1);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose} // close also triggers disable
      width="1000px"
      className="!bg-white rounded-xl overflow-hidden !p-0 !ring-0"
    >
      <div className="flex max-lg:flex-col gap-6">
        <div className="lg:w-[60%] flex items-center justify-center">
          <img
            src={current.image}
            alt="tour-step"
            className="rounded-md shadow-md max-h-[560px] object-contain"
          />
        </div>

        <div className="lg:w-[40%] flex flex-col mb-3">
          <div className="flex items-center justify-between">
            <h3 className="text-xl lg:text-2xl font-semibold text-gray-900">
              {current.title}
            </h3>

            <button
              onClick={handleClose}
              className="top-7 right-7 !bg-transparent text-gray-500 hover:text-gray-700 transition !p-0 !m-0"
            >
              <XMarkIcon className="w-6 h-6" />
            </button>
          </div>

          <p className="text-gray-600 text-sm leading-relaxed whitespace-pre-line">
            {current.description}
          </p>

          <div className="flex items-center justify-between w-full mt-5">
            <div className="flex gap-3 w-full">
              {index !== 0 && (
                <button
                  onClick={handleBack}
                  className="w-full px-5 py-2 rounded-lg border ring-1 ring-[#2D224E] text-[#2D224E] !bg-transparent"
                >
                  Back
                </button>
              )}

              {index === steps.length - 1 ? (
                <button
                  onClick={handleClose}
                  className="w-full px-5 py-2 bg-[#2D224E] text-white rounded-lg"
                >
                  Close
                </button>
              ) : (
                <button
                  onClick={handleNext}
                  className="w-full px-5 py-2 bg-[#2D224E] text-white rounded-lg"
                >
                  Next
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default DialogTour;
